import { useContext } from 'react';
import React from 'react'
import { Link } from 'react-scroll'
import './Sidebar.css';
import { themeContext} from "../../Context";

function Sidebar({sidebar}) {

    const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (

    <div className={sidebar?'sidebar sidebar--open':'sidebar'}>
        
        <ul style={{ listStyleType: "none",color: darkMode ? "rgb(49, 82, 0)" : "" }}>
            <li>
              <Link activeClass="active" to="Navbar" spy={true} smooth={true}>
                Home
              </Link>
            </li>
            <li>
              <Link to="services" spy={true} smooth={true}>
                Serivces
              </Link>
            </li>
            <li>
              <Link to="works" spy={true} smooth={true}>
                Experience
              </Link>
            </li>
            <li>
              <Link to="portfolio" spy={true} smooth={true}>
                Protfolio
              </Link>
            </li>
            <li>
              <Link to="testimonial" spy={true} smooth={true}>
                Testimonial
              </Link>
            </li>
          </ul>
          <div className="copy" style={{fontSize:'.5rem',position:'absolute',bottom:'5%',left:'20%',fontWeight:'100'}}>
            &copy; Copyright 2023.Siddiqui Abdul
          </div>
        </div>
  )
}

export default Sidebar